(function () {
    'use strict';

    angular
        .module('physicalFairs')
        .controller('PhysicalFairStudentsAnalyticController', PhysicalFairStudentsAnalyticController);

    PhysicalFairStudentsAnalyticController.$inject = ['$uibModal', 'ExpoService', 'CitiesByExpoService', 'PhysicalFairService'];


    function PhysicalFairStudentsAnalyticController($uibModal, ExpoService, CitiesByExpoService, PhysicalFairService) {
        var vm = this;


        vm.flag                  = false;
        vm.expos                 =[];
        vm.expoSelected          =[];
        vm.cities                =[];
        vm.arrayDays             =[
            '4 weeks before',
            '3 weeks before',
            '2 weeks before',
            '10 days before',
            '9 days before',
            '8 days before',
            '7 days before',
            '6 days before',
            '5 days before',
            '4 days before',
            '3 days before',
            '2 days before',
            '1 day before',
            'Event day'
        ];
        vm.i                     =-1;

        vm.titleCity             ='';
        vm.titleCountry          ='';

        vm.selectExpo            = selectExpo;
        vm.selectCitiesByExpo    = selectCitiesByExpo;
        vm.getByFilter           = getByFilter;
        vm.quality               = quality;
        vm.citySelected          = [];

        function activate() {
            vm.selectExpo();
        }

        function selectExpo () {
            ExpoService.getExpos().then(function(response){
                    vm.expos = response.data;
            }).catch(function(err) {

            });
        }

        function selectCitiesByExpo () {
            vm.cities               = [];
            vm.citySelected         = [];
            CitiesByExpoService.getCities(vm.expoSelected.id).then(function(response){
                vm.cities = response.data;
            }).catch(function(err) {

            });
        }


        function getByFilter() {
            vm.flag = false;
            vm.query = {};

            vm.query['expo_id']    = vm.expoSelected.id;
            vm.query['city_id'] = vm.citySelected.id;

            PhysicalFairService.getByFilterStudentsAnalytic(vm.query).then(function(response){
                vm.expo = response.data;
                vm.flag = true;

                vm.titleCity = vm.citySelected.city_name;
                vm.titleCountry = vm.expoSelected.name;
            }).catch(function(err){

            });

            vm.flagForViewGraph = true;
        }

        function quality(family, total){
            family = parseInt(family,10);
            total = parseInt(total,10);

            if(total !== 0)
                return (family/(total/100)).toFixed(2);
            else
                return 0;
        }

        activate();

    }

})();